(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Ffaq.tsx&page=%2Ffaq!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__("./src/pages/faq.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/SEO/Static.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ CareersHeader; },
/* harmony export */   "BV": function() { return /* binding */ FaqSEO; },
/* harmony export */   "FV": function() { return /* binding */ TermsHeader; },
/* harmony export */   "Q_": function() { return /* binding */ GuidelinesHeader; },
/* harmony export */   "XJ": function() { return /* binding */ PrivacyPolicySEO; },
/* harmony export */   "d5": function() { return /* binding */ AboutHeader; }
/* harmony export */ });
/* unused harmony export CaPrivacyRightsHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const AboutHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "About",
        description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token.",
        canonical: "https://iq.wiki/static/about",
        openGraph: {
            title: "About",
            description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token."
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const FaqSEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "FAQ",
        description: "Frequently Asked Questions about IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/faq",
        openGraph: {
            title: "FAQ",
            description: "Frequently Asked Questions about IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const PrivacyPolicySEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Policy",
        description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/privacy",
        openGraph: {
            title: "Our Policy",
            description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CareersHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Jobs",
        description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/careers",
        openGraph: {
            title: "Jobs",
            description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CaPrivacyRightsHeader = ()=>/*#__PURE__*/ _jsx(NextSeo, {
        title: "CA Privacy Rights",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/CaPrivacyRights",
        openGraph: {
            title: "CA Privacy Rights",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const TermsHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Terms of Service ",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/terms",
        openGraph: {
            title: "Terms of Service",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const GuidelinesHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Guidelines",
        description: "IQ.Wiki guidelines for the community and network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/guidelines",
        openGraph: {
            title: "Our Guidelines",
            description: "IQ.Wiki guidelines for the community and network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });


/***/ }),

/***/ "./src/pages/faq.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
;// CONCATENATED MODULE: ./src/components/Faq/FaqHeader.tsx




const FaqHeader = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                lineHeight: "shorter",
                as: "h1",
                size: "2xl",
                letterSpacing: "wide",
                fontSize: {
                    base: "3xl",
                    md: "4xl",
                    lg: "5xl"
                },
                children: "".concat(t("faqHeader"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                mt: {
                    base: 2,
                    lg: 4,
                    md: 2
                },
                fontSize: {
                    base: "sm",
                    md: "md",
                    lg: "xl"
                },
                color: "#4A5568",
                children: "".concat(t("faqPhrase"))
            })
        ]
    });
};
/* harmony default export */ var Faq_FaqHeader = (FaqHeader);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/descendant/dist/index.esm.js
var descendant_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/descendant/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var react_context_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-context/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-controllable-state/dist/index.esm.js
var react_use_controllable_state_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-controllable-state/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js
var react_use_merge_refs_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/transition/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var styled_system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
// ../../../react-shim.js


// src/accordion-button.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/accordion-context.ts


var [AccordionStylesProvider, useAccordionStyles] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
});
var [AccordionItemProvider, useAccordionItemContext] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
});
var [
  AccordionDescendantsProvider,
  useAccordionDescendantsContext,
  useAccordionDescendants,
  useAccordionDescendant
] = (0,descendant_dist_index_esm/* createDescendantContext */.n)();

// src/accordion-button.tsx
var AccordionButton = (0,system_dist_index_esm/* forwardRef */.Gp)(function AccordionButton2(props, ref) {
  const { getButtonProps } = useAccordionItemContext();
  const buttonProps = getButtonProps(props, ref);
  const styles = useAccordionStyles();
  const buttonStyles = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    outline: 0,
    ...styles.button
  };
  return /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.button */.m$.button, {
    ...buttonProps,
    className: cx("chakra-accordion__button", props.className),
    __css: buttonStyles
  });
});
AccordionButton.displayName = "AccordionButton";

// src/accordion-icon.tsx


// src/use-accordion.ts




function useAccordion(props) {
  const {
    onChange,
    defaultIndex,
    index: indexProp,
    allowMultiple,
    allowToggle,
    ...htmlProps
  } = props;
  allowMultipleWarning(props);
  allowMultipleAndAllowToggleWarning(props);
  const descendants = useAccordionDescendants();
  const [focusedIndex, setFocusedIndex] = (0,react.useState)(-1);
  (0,react.useEffect)(() => {
    return () => {
      setFocusedIndex(-1);
    };
  }, []);
  const [index, setIndex] = (0,react_use_controllable_state_dist_index_esm/* useControllableState */.T)({
    value: indexProp,
    defaultValue() {
      if (allowMultiple)
        return defaultIndex ?? [];
      return defaultIndex ?? -1;
    },
    onChange
  });
  const getAccordionItemProps = (idx) => {
    let isOpen = false;
    if (idx !== null) {
      isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
    }
    const onChange2 = (isOpen2) => {
      if (idx === null)
        return;
      if (allowMultiple && Array.isArray(index)) {
        const nextState = isOpen2 ? index.concat(idx) : index.filter((i) => i !== idx);
        setIndex(nextState);
      } else if (isOpen2) {
        setIndex(idx);
      } else if (allowToggle) {
        setIndex(-1);
      }
    };
    return { isOpen, onChange: onChange2 };
  };
  return {
    index,
    setIndex,
    htmlProps,
    getAccordionItemProps,
    focusedIndex,
    setFocusedIndex,
    descendants
  };
}
var [AccordionProvider, useAccordionContext] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function useAccordionItem(props) {
  const { isDisabled, isFocusable, id, ...htmlProps } = props;
  const { getAccordionItemProps, setFocusedIndex } = useAccordionContext();
  const buttonRef = (0,react.useRef)(null);
  const reactId = (0,react.useId)();
  const uid = id ?? reactId;
  const buttonId = `accordion-button-${uid}`;
  const panelId = `accordion-panel-${uid}`;
  focusableNotDisabledWarning(props);
  const { register, index, descendants } = useAccordionDescendant({
    disabled: isDisabled && !isFocusable
  });
  const { isOpen, onChange } = getAccordionItemProps(index === -1 ? null : index);
  warnIfOpenAndDisabled({ isOpen, isDisabled });
  const onOpen = () => {
    onChange == null ? void 0 : onChange(true);
  };
  const onClose = () => {
    onChange == null ? void 0 : onChange(false);
  };
  const onClick = (0,react.useCallback)(() => {
    onChange == null ? void 0 : onChange(!isOpen);
    setFocusedIndex(index);
  }, [index, setFocusedIndex, isOpen, onChange]);
  const onKeyDown = (0,react.useCallback)((event) => {
    const keyMap = {
      ArrowDown: () => {
        const next = descendants.nextEnabled(index);
        next == null ? void 0 : next.node.focus();
      },
      ArrowUp: () => {
        const prev = descendants.prevEnabled(index);
        prev == null ? void 0 : prev.node.focus();
      },
      Home: () => {
        const first = descendants.firstEnabled();
        first == null ? void 0 : first.node.focus();
      },
      End: () => {
        const last = descendants.lastEnabled();
        last == null ? void 0 : last.node.focus();
      }
    };
    const action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, index]);
  const onFocus = (0,react.useCallback)(() => {
    setFocusedIndex(index);
  }, [setFocusedIndex, index]);
  const getButtonProps = (0,react.useCallback)(function getButtonProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      type: "button",
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(register, buttonRef, ref),
      id: buttonId,
      disabled: !!isDisabled,
      "aria-expanded": !!isOpen,
      "aria-controls": panelId,
      onClick: callAllHandlers(props2.onClick, onClick),
      onFocus: callAllHandlers(props2.onFocus, onFocus),
      onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown)
    };
  }, [
    buttonId,
    isDisabled,
    isOpen,
    onClick,
    onFocus,
    onKeyDown,
    panelId,
    register
  ]);
  const getPanelProps = (0,react.useCallback)(function getPanelProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      ref,
      role: "region",
      id: panelId,
      "aria-labelledby": buttonId,
      hidden: !isOpen
    };
  }, [buttonId, isOpen, panelId]);
  return {
    isOpen,
    isDisabled,
    isFocusable,
    onOpen,
    onClose,
    getButtonProps,
    getPanelProps,
    htmlProps
  };
}
function allowMultipleWarning(props) {
  const index = props.index || props.defaultIndex;
  const condition = index != null && !Array.isArray(index) && props.allowMultiple;
  warn({
    condition: !!condition,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof index},`
  });
}
function allowMultipleAndAllowToggleWarning(props) {
  warn({
    condition: !!(props.allowMultiple && props.allowToggle),
    message: `If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not`
  });
}
function focusableNotDisabledWarning(props) {
  warn({
    condition: !!(props.isFocusable && !props.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function warnIfOpenAndDisabled(props) {
  warn({
    condition: props.isOpen && !!props.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}

// src/accordion-icon.tsx
function AccordionIcon(props) {
  const { isOpen, isDisabled } = useAccordionItemContext();
  const { reduceMotion } = useAccordionContext();
  const _className = cx("chakra-accordion__icon", props.className);
  const styles = useAccordionStyles();
  const iconStyles = {
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...styles.icon
  };
  return /* @__PURE__ */ react.createElement(dist_index_esm/* Icon */.JO, {
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles,
    ...props
  }, /* @__PURE__ */ react.createElement("path", {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }));
}
AccordionIcon.displayName = "AccordionIcon";

// src/accordion-item.tsx


var AccordionItem = (0,system_dist_index_esm/* forwardRef */.Gp)(function AccordionItem2(props, ref) {
  const { children, className } = props;
  const { htmlProps, ...context } = useAccordionItem(props);
  const styles = useAccordionStyles();
  const containerStyles = {
    ...styles.container,
    overflowAnchor: "none"
  };
  const ctx = (0,react.useMemo)(() => context, [context]);
  return /* @__PURE__ */ react.createElement(AccordionItemProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion__item", className),
    __css: containerStyles
  }, typeof children === "function" ? children({
    isExpanded: !!context.isOpen,
    isDisabled: !!context.isDisabled
  }) : children));
});
AccordionItem.displayName = "AccordionItem";

// src/accordion-panel.tsx


var AccordionPanel = (0,system_dist_index_esm/* forwardRef */.Gp)(function AccordionPanel2(props, ref) {
  const { className, motionProps, ...rest } = props;
  const { reduceMotion } = useAccordionContext();
  const { getPanelProps, isOpen } = useAccordionItemContext();
  const panelProps = getPanelProps(rest, ref);
  const _className = cx("chakra-accordion__panel", className);
  const styles = useAccordionStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  const child = /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.div */.m$.div, {
    ...panelProps,
    __css: styles.panel,
    className: _className
  });
  if (!reduceMotion) {
    return /* @__PURE__ */ react.createElement(transition_dist_index_esm/* Collapse */.UO, {
      in: isOpen,
      ...motionProps
    }, child);
  }
  return child;
});
AccordionPanel.displayName = "AccordionPanel";

// src/accordion.tsx


var Accordion = (0,system_dist_index_esm/* forwardRef */.Gp)(function Accordion2({ children, reduceMotion, ...props }, ref) {
  const styles = (0,system_dist_index_esm/* useMultiStyleConfig */.jC)("Accordion", props);
  const ownProps = (0,styled_system_dist_index_esm/* omitThemingProps */.Lr)(props);
  const { htmlProps, descendants, ...context } = useAccordion(ownProps);
  const ctx = (0,react.useMemo)(() => ({ ...context, reduceMotion: !!reduceMotion }), [context, reduceMotion]);
  return /* @__PURE__ */ react.createElement(AccordionDescendantsProvider, {
    value: descendants
  }, /* @__PURE__ */ react.createElement(AccordionProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(AccordionStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion", props.className),
    __css: styles.root
  }, children))));
});
Accordion.displayName = "Accordion";

// src/use-accordion-item-state.ts
function useAccordionItemState() {
  const { isOpen, isDisabled, onClose, onOpen } = useAccordionItemContext();
  return { isOpen, onClose, isDisabled, onOpen };
}


// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Faq/SingleLink.tsx



const SingleLink = (param)=>{
    let { href , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Link */.rU, {
        href: href,
        target: "_blank",
        textDecoration: "underline",
        color: "#FF5CAA ",
        children: [
            title,
            " "
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
;// CONCATENATED MODULE: ./src/components/Faq/AccordionFAQItem.tsx




const AccordionFAQItem = (param)=>{
    let { title , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
        defaultIndex: [
            1
        ],
        allowMultiple: true,
        my: {
            base: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, {
            borderRadius: "5",
            py: {
                base: 5
            },
            border: "none",
            _light: {
                boxShadow: "0px 0px 20px 11px #80808012",
                bg: "#ffffff"
            },
            _dark: {
                bg: "#2D3748"
            },
            children: (param)=>{
                let { isExpanded  } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontWeight: "bold",
                            fontSize: {
                                base: "sm",
                                md: "md",
                                lg: "xl"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionButton, {
                                _hover: {
                                    bg: "none"
                                },
                                _focus: {
                                    outline: "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "1",
                                        textAlign: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            fontWeight: "bold",
                                            fontSize: {
                                                base: "sm",
                                                md: "md",
                                                lg: "md"
                                            },
                                            children: title
                                        })
                                    }),
                                    isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* MinusIcon */.V_, {
                                        fontSize: "12px"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* AddIcon */.dt, {
                                        fontSize: "12px"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionPanel, {
                            pb: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: {
                                    base: "sm",
                                    md: "sm",
                                    lg: "sm"
                                },
                                lineHeight: 2,
                                children: content
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var Faq_AccordionFAQItem = (AccordionFAQItem);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedFAQ/WhatIsIQWiki.tsx




const WhatIsIQWiki = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
        title: "What is IQ.wiki?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "IQ.wiki formerly Everipedia is the largest",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/blockchain",
                    title: "blockchain"
                }),
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/cryptocurrency",
                    title: "cryptocurrency"
                }),
                " ",
                "encyclopedia in the world with thousands of pages. IQ.wiki integrates artificial intelligence for use cases including summarizing wiki articles for search engines. The",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/iq",
                    title: "IQ token"
                }),
                " powers IQ.wiki and all edits on the platform are recorded on-chain through",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/polygon",
                    title: "Polygon"
                }),
                "and the InterPlanetary File System (IPFS). The encyclopedia is governed by IQ token stakers."
            ]
        })
    });
};
/* harmony default export */ var GettingStartedFAQ_WhatIsIQWiki = (WhatIsIQWiki);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedFAQ/EditingIQWiki.tsx




const EditingIQWiki = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
        title: "How do I join Brainlist and start editing IQ.wiki?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "While the site is in beta, to get started editing you need to",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    title: "sign up for the Brainlist using this form",
                    href: "https://forms.gle/bmMce4r3JJckpSNJ7"
                }),
                " ",
                ".",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " As part of the signing up, you’ll need to create a Polygon address as well as a",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    title: "MetaMask",
                    href: "https://metamask.io/"
                }),
                " or",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    title: "WalletConnect",
                    href: "https://walletconnect.com/"
                }),
                " ",
                "wallet. For more information on how to set up a Polygon address with your MetaMask wallet check out this",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    title: "Coindesk guide",
                    href: "https://www.coindesk.com/learn/how-to-connect-metamask-to-the-polygon-network/"
                }),
                ". ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " After you submit your Brainlist application you will receive an initial confirmation email. And then if you are approved to Brainlist you will receive an approval email. ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "We’ll be approving people for Brainlist on a rolling basis so don’t worry if you’ve already applied and have not been approved yet. ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "After the beta period, IQ.wiki plans on stopping Brainlist and introducing HiIQ Brain Pass NFTs which will provide several benefits including the ability to edit on IQ.wiki. Users will get the HiIQ Brain Pass NFTs by staking IQ with HiIQ or be able to acquire the NFTs by purchasing them with IQ tokens."
            ]
        })
    });
};
/* harmony default export */ var GettingStartedFAQ_EditingIQWiki = (EditingIQWiki);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedFAQ/WhatIsIQToken.tsx




const WhatIsIQToken = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
        title: "What is the IQ token?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "The IQ token is a",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/cryptocurrency",
                    title: "cryptocurrency"
                }),
                " ",
                "dedicated to building a more intelligent future through artificial intelligence and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/blockchain",
                    title: "blockchain"
                }),
                " ",
                "technology. The IQ token powers a knowledge ecosystem including applications such as",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/iqwiki",
                    title: "IQ.wiki"
                }),
                ", the world's largest cryptocurrency and blockchain encyclopedia. IQ.wiki integrates AI for tasks including summarizing wiki articles. The IQ token is a DeFi and governance token with IQ stakers governing the platform. The token is managed by",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/braindao",
                    title: "BrainDAO"
                }),
                " ",
                "which holds a treasury of IQ tokens,",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/stablecoin",
                    title: "stablecoins"
                }),
                " ",
                ", blue chip",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    href: "https://iq.wiki/wiki/non-fungible-token-nft",
                    title: "NFTs"
                }),
                " ",
                ", and other digital assets."
            ]
        })
    });
};
/* harmony default export */ var GettingStartedFAQ_WhatIsIQToken = (WhatIsIQToken);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedFAQ/WhereToGetIQTokens.tsx




const WhereToGetIQTokens = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
        title: "Where do I get IQ tokens?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can get IQ tokens from a variety of centralized and decentralized exchanges including Binance, Crypto.com, Fraxswap, and more. See the",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleLink, {
                    title: "Exchanges",
                    href: "https://learn.everipedia.org/iq/iq/exchanges"
                }),
                " ",
                "section of our Learn site for the full list."
            ]
        })
    });
};
/* harmony default export */ var GettingStartedFAQ_WhereToGetIQTokens = (WhereToGetIQTokens);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedFAQ/IQRules.tsx




const IQRules = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
        title: "IQ.wiki Rules",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Standards:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* UnorderedList */.QI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "IQ.wiki is a cryptocurrency encyclopedia so all IQ.wiki articles must be related to the cryptocurrency or blockchain space."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ListItem */.HC, {
                            children: [
                                "For people to have a wiki, they need to have made contributions to the crypto space or worked in the crypto space.",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Editors should follow the minimum content requirements: at least 300 words in the wiki’s main body, using appropriate categories and tags, and uploaded media should be only of high quality."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "All content has to be cited. This allows the community to check editors’ work and work with editors in an environment that is inherently collaborative."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "All content has to be neutral. Because IQ.wiki is a knowledge base, editors should think from the perspective of an academic scholar and provide unbiased information."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "All content should be written in the third person."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Spelling and grammar should be carefully checked before an edit submission."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Pages that have a completion score lower than 50 are subject to removal."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "To maintain the quality of the encyclopedia low quality wikis will be removed."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Do Not:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* UnorderedList */.QI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Plagiarize content that is not your own and represent it as your work; this typically includes copying/pasting content without citing its original source and giving proper credit to the creator. It also includes violating copyright."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Vandalize: deliberately attempt to add, change, or remove content to tarnish the wiki."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                            children: "Spam: reference content that attempts to promote irrelevant or inappropriate products to a page; these edit proposals tend to be in the form of advertisements and violate IQ.wiki’s policy of writing in a neutral tone."
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GettingStartedFAQ_IQRules = (IQRules);

;// CONCATENATED MODULE: ./src/components/Faq/GettingStartedAccordion.tsx









const GettingStartedAccordion = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        mt: 10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                gap: 2,
                align: "center",
                justify: "center",
                w: "fit-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                        as: ri_index_esm/* RiFlagFill */.msm,
                        boxSize: {
                            base: "25px",
                            lg: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "bold",
                        mt: 5,
                        textAlign: {
                            base: "center",
                            md: "left"
                        },
                        fontSize: {
                            base: "md",
                            lg: "xl"
                        },
                        mb: 4,
                        children: "Getting Started"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                defaultIndex: [
                    1
                ],
                allowMultiple: true,
                my: {
                    base: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedFAQ_WhatIsIQWiki, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedFAQ_EditingIQWiki, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedFAQ_WhatIsIQToken, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedFAQ_WhereToGetIQTokens, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedFAQ_IQRules, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Faq_GettingStartedAccordion = (GettingStartedAccordion);

;// CONCATENATED MODULE: ./src/components/Faq/CreateWikisFAQ.tsx





const CreateWikisFAQ = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        mt: 10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                gap: 2,
                align: "center",
                justify: "center",
                w: "fit-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                        as: ri_index_esm/* RiSettings3Fill */.BUe,
                        boxSize: {
                            base: "25px",
                            lg: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "bold",
                        mt: 5,
                        textAlign: {
                            base: "center",
                            md: "left",
                            lg: "left"
                        },
                        fontSize: {
                            base: "md",
                            md: "md",
                            lg: "xl"
                        },
                        mb: 4,
                        children: "Creating Wikis on IQ.wiki"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Getting Started",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Before you can create or edit an IQ.wiki article you'll need to click the wallet icon and log in with your Brainlisted Polygon address using MetaMask or WalletConnect. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Prior to creating the new wiki, check if it does not exist yet. Go to the Search Bar and insert the title. The site will search our existing database to see if an article about the same topic already exists. If it does, edit the existing article. If there are no suggestions from the system, you can feel free to create a new article. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Click the Create Wiki button in the header navigation. Add your desired article title. Make sure that it is short and comprehensive - the system will generate the unique URL from the title.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Getting Started with creating wikis on IQ.WIKI",
                            src: "https://www.youtube.com/embed/Y4gWJUFchrc"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Adding a featured image",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "To add or update a featured image, click on the placeholder image. You can easily add a photo by dragging and dropping it or clicking to select an image from your PC. You can also click on Image URL and paste in a link to the image and the system will fetch it automatically.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Adding a featured image",
                            src: "https://www.youtube.com/embed/3DFzzleCCNo"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Filling in the article",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "This is your chance to start writing and explaining the topic of your article. The intro should answer the basics and provide the most important info while headers can be used to create sections that provide additional details."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Adding a citation",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "To add a reference or citation to the body of an article, first select where you want to add the citation by clicking on the place in the article where you would like to add the citation (you can start with adding a citation at the end of the first paragraph).",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " To actually add the citation click the “Cite” button, enter the URL, and a short description of the link you’re choosing to add (for example, you can enter the title of the article, the author, and/or the publishing date in the description). To actually insert the reference, click the pink “Cite” button. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Adding a citation",
                            src: "https://www.youtube.com/embed/NrAUvtOpY0E"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: " Submitting a wiki",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "When you're finished editing your IQ.wiki article, fill in the Wiki Summary section above the main image to give the readers the overall idea of the article. You are also required to select a category, tags and add social media links in the Edit Wiki Details section. When all these steps are done, you can hit the Publish button to save your page. You will have the option to add a comment while publishing. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Comments give editors the opportunity to provide additional context or rationale for their edits. This creates more transparency within the community. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " After pushing the Publish button, the system will initiate a gasless transaction, which you should sign with your wallet. Press Sign in the wallet pop-up window. In several moments your page should be recorded on the blockchain. Once your changes have been authorized by your wallet, you can see your wiki in the Reading Mode. After submission, you will also be able to view the transaction on block explorer and IPFS. If the changes are not visible make sure to hard refresh the page. Most edits go through in under a minute but it could take a few minutes if the Polygon network is congested. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Submitting a wiki",
                            src: "https://www.youtube.com/embed/8ml3S6KUX3U"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " If you're looking for ways to improve your editing skills and make your pages stand out with Twitter feeds, headers, links to other IQ.wiki pages, quotes, categories, and infoboxes check out our Editing Guide below."
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Faq_CreateWikisFAQ = (CreateWikisFAQ);

;// CONCATENATED MODULE: ./src/components/Faq/EditingWikisFAQ.tsx





const EditingWikisFAQ = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        mt: 10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                gap: 2,
                align: "center",
                justify: "center",
                w: "fit-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                        as: ri_index_esm/* RiEdit2Fill */.cpK,
                        boxSize: {
                            base: "25px",
                            lg: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "bold",
                        mt: 5,
                        textAlign: {
                            base: "center",
                            md: "left",
                            lg: "left"
                        },
                        fontSize: {
                            base: "md",
                            md: "md",
                            lg: "xl"
                        },
                        mb: 4,
                        children: "Editing Wikis on IQ.wiki"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Getting Started",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Before you can edit an IQ.wiki article you'll need to log in with your Brainlisted Polygon address using MetaMask or Walletconnect. Editing an article is quite similar to creating an article. The only difference is that you need to start with an existing IQ.wiki article and open the Edit Mode instead of starting with the Create Wiki button."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Editing Mode",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "To open the Editing Mode and start editing an IQ.wiki article click the Edit button. To learn the basics of editing on IQ.wiki, how to add a featured image, information, and citations as well as how to submit your page, first make sure to read the Creating an Article of this FAQ page."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Headers and Sections",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "You can use headers like Overview, Use Cases, and Tokenomics, to create different sections on your wiki and make it easier to read.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " To add a header click the H button, choose the appropriate size and type in the title of the section. You can use H1 to H6 to create subsections as part of the original section. Use “paragraph” for the plain text.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Headers and Sections",
                            src: "https://www.youtube.com/embed/qshwjtDtNss"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Quotes",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Quotes are a great way to add the perspectives of the people/companies involved or covered in the wiki. To add a quote select the quoted information and click the blockquote button.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Quotes on editing wikis",
                            src: "https://www.youtube.com/embed/P1yHumUmO6k"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Adding Item to the Media Gallery",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "To add an image to the media gallery, navigate to the media gallery on the right side of the article (below the main image) and click new “Add images/video”. You can drag and drop an image or video or click to select it from your PC. You can paste a YouTube or image link as well as the system will automatically fetch the media."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Embedding Images & Videos",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "To add an image or video to the body of an IQ.wiki article, first select where you want to add the media by clicking on the place in the article where you would like to add the media (you can start with adding media to the introduction by placing your cursor before the first word of the article). ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " To actually add the media click the “Media” button in the editor toolbar, select the photo or video, and press the one you want to add.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Quotes on editing wikis",
                            src: "https://www.youtube.com/embed/_54xE_e5BiQ"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Categories and Tags",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Categories allow users to group wikis together by topic and make it easier for readers to discover related wikis. To add a category click the Edit Categories section and type out the category you want to add. The six initial categories on IQ.wiki are: NFTs, Decentralized Finance, Exchanges, Cryptocurrencies, People in Crypto and DAOs. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Tags allow users to go from one page to another within the specific topic in question. Pressing on some specific tags, for example, Games will lead a user to the list with all the wikis about crypto-based games on IQ.wiki. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Both of these features are accessible from Edit Wiki Details panel that can be found under the main image.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Quotes on editing wikis",
                            src: "https://www.youtube.com/embed/XWFeUeEVW0c"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Adding Internal Links",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Adding a link to another IQ.wiki article is a great way to refer people to information related to the article you are editing. To add an internal link, click on the place in the article where you would like to add an internal link, press “Insert Wiki Link” and type in the article you would like to include. Then press “Link” to insert it. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " *There is an “override text” option, which allows you to make the clickable text of the link different from the title of the IQ.wiki article. By using the override text feature, you can have BAYC appear as the visible text instead of Bored Ape Yacht Club.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Quotes on editing wikis",
                            src: "https://www.youtube.com/embed/WyLVpULmyP4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_AccordionFAQItem, {
                title: "Edit History",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "To see the past edits that have been made to an IQ.wiki article you can click on the History button which is located below the Edit button. The History feature allows users to examine the different versions of an article and the differences between them on a special timeline. The History page also links to the Polygon transaction and IPFS hash for each edit. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "Quotes on editing wikis",
                            src: "https://www.youtube.com/embed/gjYErj7O-PQ"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Faq_EditingWikisFAQ = (EditingWikisFAQ);

// EXTERNAL MODULE: ./src/components/SEO/Static.tsx
var Static = __webpack_require__("./src/components/SEO/Static.tsx");
;// CONCATENATED MODULE: ./src/pages/faq.tsx








const FAQ = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Static/* FaqSEO */.BV, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                bgColor: "pageBg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    w: "min(90%, 1100px)",
                    mx: "auto",
                    direction: "column",
                    py: {
                        lg: 20
                    },
                    mb: {
                        base: 17,
                        lg: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_FaqHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_GettingStartedAccordion, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_CreateWikisFAQ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_EditingWikisFAQ, {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var faq = (FAQ);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Ffaq.tsx&page=%2Ffaq!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);